import { SubtaskResource } from "../../api/resources/subtask/subtaskResourceStruct";
import { ParsedSubtask } from "../../types/types";

export const parseSubtasks = (subtasks: SubtaskResource[]): ParsedSubtask[] => {
  const parsedSubtasks = subtasks.map((subtask) => {
    const {
      id,
      attributes: { name, comment, pointsNumber, rating },
      relationships: { completedBy },
    } = subtask;

    return {
      id,
      completedBy: completedBy.data?.id ? completedBy.data.id : null,
      done: Boolean(subtask.attributes.completedAt),
      name,
      comment,
      pointsNumber,
      rating,
    };
  });
  return parsedSubtasks;
};
